import React from 'react';

export const FileTypeCell = ({cell: {value: {type, label}}}) => {
    return (
        <span>{label}</span>
    )
};
